<template>
<div v-if="condition" class="mt-1 mb-1 grid">

<div class="col-11">

<Dropdown :filter="true"  v-model="condition.customattribute_id" :options="customattributes" optionLabel="name" optionValue="id" class="p-inputtext-sm" @change="conditionCustomattributeSelected"/>

<template v-if="customattribute">

<span class="ml-2">niteliği için girilen değer, </span>
<!-- condition value-->
<InputNumber   placeholder="Sayısal değer" v-if="customattribute.type=='number'" v-model="condition.numerical_val" class="ml-2 p-inputtext-sm" />

<InputText  type="text" placeholder="Text değeri" v-if="customattribute.type=='string'" v-model="condition.text_val" class="ml-2 p-inputtext-sm" />

<Dropdown :filter="true" v-if="customattribute.type=='select' " v-model="condition.numerical_val" :options="customattribute.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" />

<Dropdown  v-if=" customattribute.type=='boolean'" v-model="condition.numerical_val" :options="booleanoptions" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" />

<!-- condition value-->

<!-- condition operation-->
<Dropdown  v-if="customattribute.type=='number'" v-model="condition.execution_type" :options="numberoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="customattribute.type=='string' " v-model="condition.execution_type" :options="textoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="customattribute.type=='select'|| customattribute.type=='boolean'" v-model="condition.execution_type" :options="selectoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>
<!-- condition operation-->

</template>

<template v-if="ready_to_include">
<Dropdown  v-model="condition.operator" :options="conditionoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionOperatorSelected"/>

</template>

 
</div>

<div class="col-1">
<Button v-if="show_delete" icon="pi pi-trash"  class=" p-button-danger p-button-outlined  p-button-sm " @click="removeCondition"/>
</div>

</div>
</template>

<script>
const condition_obj= {
	id:null,
	customattribute_id:null,
	operator:null,//and, or
	numerical_val:null,
	text_val:null,
	execution_type:null,//equal_to,not_equal_to,less_than,greater_than,includes,does_not_include,
	
}
export default {

  name: 'FlowConditionLine',
  props:["conditiondata","customattributes"],
  data () {
    return {
      textoperators:[
      {name:"Terimini içeriyorsa",code:"includes"},
      {name:"Terimini içermiyorsa",code:"does_not_include"},
      ],
      numberoperators:[
      {name:"değerine eşitse",code:"equal_to"},
      {name:"değerine eşit değilse",code:"not_equal_to"},
      {name:"değerinden büyükse",code:"greater_than"},
      {name:"değerinden küçükse",code:"less_than"},
      ],
      selectoperators:[
      {name:"değerine eşitse",code:"equal_to"},
      {name:"değerine eşit değilse",code:"not_equal_to"},
      ],
      conditionoperators:[
      {name:"ve",code:"and"},
      {name:"ya da",code:"or"},
      {name:"tamamla",code:"execute"},
      ],
      booleanoptions:[
      {name:"açık",code:1},
      {name:"kapalı",code:0},
      ],
      ready_to_include:false,
      show_delete:true,
      condition:null,
      customattribute:null
    }
  },
  watch:{
  	conditiondata(newval)
  	{
  		console.log("watch")
  		this.resolveCondition()
  	}
  },
  mounted()
  {
  	this.resolveCondition()
  },
  methods:{  	
  	resolveCondition(newval)
  	{
  		this.condition = this.conditiondata
  		if(this.condition.customattribute_id)
  		{
  			let customattribute = this.customattributes.find((item)=>{return item.id == this.condition.customattribute_id})
  			if(customattribute.options.length)
	    	{
	    		for(let option of customattribute.options)
			      {
			      	if(option.name.length>30)
			        {
			            option.name = option.name.substring(0, 30)+"...";
			        }
			      }
	    	}
    	
    		this.customattribute = customattribute

  			this.ready_to_include = true
  			this.show_delete = true
  		}
  	},
    conditionCustomattributeSelected(id)
    {
    	console.log(this.condition.customattribute_id)
    	
    	let customattribute  = this.customattributes.find((item)=>{return item.id == this.condition.customattribute_id})
    	console.log(customattribute)

    	this.condition.execution_type = null
    	this.condition.numerical_val = null
    	this.condition.text_val = null
    	this.condition.operator = null
    	

    	if(this.condition.customattribute_id=="no_condition")
    	{
    		this.show_delete = true
	    	this.condition.operator = "execute"
    		this.$emit("conditionConcluded",this.condition)
    		return false
    	}
    	this.ready_to_include = false
    	console.log("wrong")



    	if(customattribute.options.length)
    	{
    		for(let option of customattribute.options)
		      {
		      	if(option.name.length>30)
		        {
		            option.name = option.name.substring(0, 30)+"...";
		        }
		      }
    	}
    	
    	this.customattribute = customattribute
    },
    conditionExecutionSelected()
    {
    	this.ready_to_include = true
    },
    conditionOperatorSelected()
    {

    	this.show_delete = true
    	this.$emit("conditionConcluded",this.condition)
    },
    removeCondition()
    {
    	this.$emit("removeCondition",this.condition)
    },
  },

}
</script>

<style lang="css" scoped>
</style>